/**
 * GraphQL queries and mutations for the Integrations page (ShelterLuv).
 */

import { gql } from '@apollo/client';

/** Fetch the current user's ShelterLuv configuration status. Returns null if not configured. */
export const rescueShelterluvStatusQuery = gql`
  query rescueShelterluvStatus {
    rescueShelterluvStatus {
      enabled
      apiKeyEndsWith
      lastImportAt
      thirdPartyChipIncrementalEnabled
      thirdPartyChipBackfillEnabled
    }
  }
`;

export interface RescueShelterluvStatusData {
  rescueShelterluvStatus: {
    enabled: boolean;
    apiKeyEndsWith: string;
    lastImportAt: string | null;
    thirdPartyChipIncrementalEnabled: boolean;
    thirdPartyChipBackfillEnabled: boolean;
  } | null;
}

/** Fetch the current user's reseller info including shelterluv chip stats. */
export const rescueResellerStatsQuery = gql`
  query rescueResellerStats {
    currentUser {
      id
      chipReseller {
        id
        name
        stats {
          chipsRegisteredOnShelterluv
        }
      }
    }
  }
`;

export interface RescueResellerStatsData {
  currentUser: {
    id: string;
    chipReseller: {
      id: string;
      name: string;
      stats: {
        chipsRegisteredOnShelterluv: number;
      };
    } | null;
  };
}

/** Enable ShelterLuv integration with an API key and sync options. */
export const rescueEnableShelterluvMutation = gql`
  mutation rescueEnableShelterluv($input: RescueEnableShelterluvInput!) {
    rescueEnableShelterluv(input: $input) {
      id
      name
      preferences {
        shelterluv {
          enabled
          apiKeyEndsWith
          lastImportAt
          thirdPartyChipBackfillEnabled
          thirdPartyChipIncrementalEnabled
        }
      }
      stats {
        chipsRegisteredOnShelterluv
      }
    }
  }
`;

export interface RescueEnableShelterluvData {
  rescueEnableShelterluv: {
    id: string;
    name: string;
    preferences: {
      shelterluv: {
        enabled: boolean;
        apiKeyEndsWith: string;
        lastImportAt: string | null;
        thirdPartyChipBackfillEnabled: boolean;
        thirdPartyChipIncrementalEnabled: boolean;
      };
    };
    stats: {
      chipsRegisteredOnShelterluv: number;
    };
  };
}

/** Disable ShelterLuv integration. */
export const rescueDisableShelterluvMutation = gql`
  mutation rescueDisableShelterluv {
    rescueDisableShelterluv {
      id
      preferences {
        shelterluv {
          enabled
        }
      }
    }
  }
`;

export interface RescueDisableShelterluvData {
  rescueDisableShelterluv: {
    id: string;
    preferences: {
      shelterluv: {
        enabled: boolean;
      } | null;
    };
  };
}
